<template>
  <div id="activities-agenda-list">
    <Breadcrumbs :breadcrumbs="[
      { title: this.$t(`menu.${this.serviceSlug}`)},
      { title: this.$t('activities_agenda.list.title'), disabled: true }
    ]"/>

    <div class="list">
      <TableView
        :service="component.service"
        :component="component"
        :serviceSlug="serviceSlug"
      />
    </div>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/common/Breadcrumbs.vue';
import TableView from '@/components/activities_agenda/list/TableView.vue';
import { TABLE_ACTIVITIES_AGENDA_TABLE } from '@/local-storage/LocalStorageKeys';

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    serviceSlug: {
      type: String,
      required: true
    }
  },
  components: {
    Breadcrumbs,
    TableView
  },
  data () {
    return {
      activeFilters: 0,
      localStorageKey: TABLE_ACTIVITIES_AGENDA_TABLE,
      customQueries: null
    }
  },
}
</script>
